// @flow
import React from 'react';
import { Link } from 'react-router-dom';

import Card, { CardHeader, CardText } from 'material-ui/Card';
import List, { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';

import { cyan600, green600 } from 'material-ui/styles/colors';

const styles = {
  container: {
    paddingBottom: 0,
  },

  avatar: {
    backgroundColor: green600,
  },

  link: {
    color: cyan600,
  },
};

export default ({ slug, toggleSearchResultsDialog }) => (
  <CardText style={styles.container}>
    <List>
      <ListItem
        primaryText="Keresés mentve"
        secondaryText={
          <p>
            A keresett légtér mentésre került, bármikor megtekintheti&nbsp;
            <Link
              to={`/s/${slug}`}
              style={styles.link}
              onClick={() => toggleSearchResultsDialog(false)}
            >
              ezen a linken
            </Link>.
          </p>
        }
        secondaryTextLines={2}
        leftAvatar={
          <Avatar
            icon={<FontIcon className="material-icons">link</FontIcon>}
            color="white"
            style={styles.avatar}
          />
        }
        disabled
      />
    </List>
  </CardText>
);



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/ContactSentMessage.js